<template>
  <div>
    <span
      style="cursor: pointer;"
      v-for="(item, idx) in availableFlags"
      :key="idx"
      @click="handleClick(item)"
      :class="handleClass(item)"
    />
  </div>
</template>

<script>
const AVAILABLE_FLAGS = [
  { flag: "bra", lang: "pt-BR" },
  { flag: "usa", lang: "en" },
  { flag: "esp", lang: "esp" },
  { flag: "deu", lang: "de" },
];

export default {
  props: {
    lang: {
      type: String,
      default: "pt-BR",
    },
  },

  mounted() {
    const { flag } = this.findFlagByLang(this.lang);
    this.currentFlag = flag;
  },

  data: () => {
    return {
      currentFlag: "bra",
      availableFlags: AVAILABLE_FLAGS,
    };
  },

  methods: {
    handleClass(item) {
      const deactivated = this.currentFlag !== item.flag ? "deactivated" : "";

      return `common-button flag-button flag-icon flag-icon-${item.flag} ${deactivated}`;
    },
    checkIsActive(flag) {
      return "";
    },

    findFlagByLang(lang) {
      return AVAILABLE_FLAGS.find((e) => e.lang === lang);
    },

    handleClick({ flag, lang }) {
      if (this.currentFlag !== flag) {
        this.currentFlag = flag;
        this.$i18n.locale = lang;
        this.$emit("flagChange", lang);
      }
    },
  },
};
</script>

<style>
.flag-button {
  width: 2rem;
}

.deactivated {
  opacity: 0.7;
}
</style>
